import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  plugins: [createPersistedState()],
  state: {
    token: null,
    user: null,
    isUserLoggedIn: false,
    timeExp: ''
  },
  getters: {
    isUserLoggedIn: state => {
      return state.isUserLoggedIn
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
      // console.log("state==",state)
    },
    setUser(state, user) {
      state.user = user;
    },
    // setStatus(state, status) {
    //   state.status = status;
    // },
    setTimeExp(state, exp) {
      state.timeExp = exp;
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      commit("setToken", token);
    },
    setUser({
      commit
    }, user) {
      commit("setUser", user);
    },
    // setStatus({
    //           commit
    //         }, status) {
    //   commit("setStatus", status);
    // },
    setTimeExp({
      commit
    }, exp) {
      commit("setTimeExp", exp);
    }

  }
});
